import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { selectorFeaturedSearchCache, selectorFeaturedSearchResults } from "./selectors";
import {
  fetchFeaturedForParagraph,
  fetchFeaturedSearchRequest
} from "../../api/relevantSearch/RelevantSearchAPI";
import { systemActions } from "../../../main/src/redux/system/system.actions";
import { _sharedActionsFeaturedSearch, _sharedActionsConstantsFeaturedSearch } from "./actions";
import { LOADER_ID_FEATURED_SEARCH_SECTIONS } from "./constants";

function* _handlerFetchFeaturedSearch(fetchFn, params, onSuccess) {
  let isLoaderWasEnabled = false;

  try {
    let data;

    yield put(systemActions.loading(LOADER_ID_FEATURED_SEARCH_SECTIONS));
    isLoaderWasEnabled = true;
    data = yield call(fetchFn);

    yield put(_sharedActionsFeaturedSearch.fetchSuccess(data, params));

    if (onSuccess) {
      onSuccess(data);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log("%c[Featured Search] Error: ", "background: red; color: white;", error);
  } finally {
    if (isLoaderWasEnabled) {
      yield put(systemActions.loading(LOADER_ID_FEATURED_SEARCH_SECTIONS, true));
    }
  }
}

function* _sharedWorkerFetchFeaturedByQuery(action) {
  const {
    query, langs,
  } = action.data;

  if (!query) {
    return;
  }

  const fetchFn = () => fetchFeaturedSearchRequest(query, langs);

  yield call(_handlerFetchFeaturedSearch, fetchFn, { query, langs });
}

function* _sharedWorkerFetchFeaturedByParaId(action) {
  const { paraId, onSuccess } = action.data;

  const fetchFn = () => fetchFeaturedForParagraph(paraId);

  yield call(_handlerFetchFeaturedSearch, fetchFn, { paraId }, onSuccess);
}

export default function* _sharedSagaFeaturedSearch () {
  yield all([
    takeLatest(
      _sharedActionsConstantsFeaturedSearch.FETCH_BY_QUERY,
      _sharedWorkerFetchFeaturedByQuery
    ),
    takeLatest(
      _sharedActionsConstantsFeaturedSearch.FETCH_FOR_PARAGRAPH,
      _sharedWorkerFetchFeaturedByParaId
    ),
  ]);
};
